<div class="location-map-picker">
  <div class="map-shell">
    <div class="map-search-control">
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-icon matPrefix>search</mat-icon>
        <input
          #search_input
          matInput
          type="text"
          cdkFocusInitial
          [disabled]="loading() || load_error() !== null || mode() === LocationDialogModeEnum.View"
        />
      </mat-form-field>
    </div>

    <div #map_element class="map"></div>

    @if (loading()) {
      <div class="map-overlay">
        <mat-spinner diameter="28" />
      </div>
    }

    @if (load_error() !== null) {
      <div class="map-overlay">
        <mat-icon>map_off</mat-icon>
        <span>{{ load_error() }}</span>
      </div>
    }
  </div>
</div>
